module.exports = __webpack_public_path__ + "img/desktop-unlocked.8c140f18.png";